import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagementRoutingModule } from './management-routing.module';
import { SideNavService } from 'src/app/shared/side-nav/services/side-nav.service';
import { managementSideNavConfig } from './management-sidenav.config';
import {SubscriptionApiService} from "./modules/subscription/services/subscription-api.service";
import {SubscriptionService} from "./modules/subscription/services/subscription.service";
import {ConfirmationPopupModule} from "../../kernel/popups/popup/modules/confirmation-dialog/confirmation-popup.module";

@NgModule({
  declarations: [

  ],
  imports: [
    CommonModule,
    ManagementRoutingModule,
    ConfirmationPopupModule
  ],
  providers: [
    SubscriptionApiService,
    SubscriptionService
  ]
})
export class ManagementModule {
   constructor(sideNavService: SideNavService) {
    sideNavService.addSubMenuItems('management', managementSideNavConfig)
  }
 }
